import { render, staticRenderFns } from "./Photo-Viewer.vue?vue&type=template&id=0e727869&"
import script from "./Photo-Viewer.vue?vue&type=script&lang=ts&"
export * from "./Photo-Viewer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports